import { render, staticRenderFns } from "./PatientSelectionModal.vue?vue&type=template&id=1ddd6ea4&"
import script from "./PatientSelectionModal.vue?vue&type=script&lang=js&"
export * from "./PatientSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientSelectionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports